import type { NodeViewProps } from "@tiptap/react";
import { User } from "lucide-react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

// Hardcoded stub users — will be replaced with Convex user queries
const STUB_USERS = [
  { id: "user-1", name: "Alice Johnson" },
  { id: "user-2", name: "Bob Smith" },
  { id: "user-3", name: "Charlie Brown" },
  { id: "user-4", name: "Diana Prince" },
];

/**
 * Owner field sub-view — user selection dropdown.
 *
 * Uses a Select component with stub user data.
 * Will be upgraded to a Combobox with Convex user queries in the future.
 */
export function OwnerFieldView({ node, updateAttributes }: NodeViewProps) {
  const currentValue = (node.attrs.value as string) || undefined;
  const guidance = node.attrs.guidance as string | undefined;

  return (
    <Select value={currentValue} onValueChange={(value) => updateAttributes({ value })}>
      <SelectTrigger className="w-48">
        <User className="size-3 text-muted-foreground" />
        <SelectValue placeholder={guidance || "Select owner..."} />
      </SelectTrigger>
      <SelectContent>
        {STUB_USERS.map((user) => (
          <SelectItem key={user.id} value={user.id}>
            {user.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
